import React from 'react';
import { Dropdown } from 'semantic-ui-react';

const LanguageSelector = (props) => {
  return (
    <Dropdown
      inline
      className='icon'
      icon='caret down'
      options={props.options}
      defaultValue={props.activeLang}
      onChange={props.onChangeLanguage}
    />
  );
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/common/components/Header/LanguageSelector.js